import DeviceStorage from '../libs/device-storage';

export const state = () => ({
  current: {
    // Currently active title
    info: {
      id: ''
    },
    status: 'idle' // idle, loading, renting, ready, error, playing, paused, stopped
  },
  next: {
    // Next title to show
    info: {
      id: ''
    },
    status: 'idle' // idle, loading, renting, ready, error, playing, paused, stopped
  },
  groupsSelector: {
    status: 'idle', // idle, loading, ready
    list: []
  },
  play: {
    indexes: {
      stop: ''
    }
  },
  course: {},
  contentToPlayer: {},
  courseFinished: false,
  quiz: {
    id: '',
    data: null,
    result: null
  }
});

export const mutations = {
  setCurrentInfo(state, titleData) {
    state.current.info = { ...state.current.info, ...titleData };
  },

  setCourse(state, payload) {
    state.course = {};
    state.course = payload;
    DeviceStorage.set('course', payload);
  },

  setContentToPlayer(state, payload) {
    state.contentToPlayer = {};
    state.contentToPlayer = payload;
    DeviceStorage.set('contentToPlayer', payload);
  },

  setCourseFinished(state, payload) {
    state.courseFinished = {};
    state.courseFinished = payload;
  },

  setQuizId(state, id) {
    state.quiz.id = id;
  },

  setQuizData(state, quizData) {
    state.quiz.data = quizData;
  },
  setQuizResult(state, quizData) {
    state.quiz.result = quizData;
  },

  setNextInfo(state, titleData) {
    state.next.info = { ...state.next.info, ...titleData };
  },

  setCurrentStatus(state, value) {
    state.current.status = value;
  },

  setNextStatus(state, value) {
    state.next.status = value;
  },

  promoteNextToCurrent(state) {
    state.current.info = { ...state.next.info };
    state.current.status = state.next.status;
  },

  setTitleFavorite(state, { next, value }) {
    const details = next ? state.next.info || {} : state.current.info || {};
    details.inFavorites = !!value;
  },

  setGroupsSelector(state, groupsList) {
    state.groupsSelector.list = groupsList;
    state.groupsSelector.status = 'ready';
  },

  setGroupsSelectorStatus(state, value) {
    state.groupsSelector.status = value;
  },

  setStopIndex(state, payload) {
    state.play.indexes.stop = payload.play.indexes.stop;
  }
};

export const actions = {
  getGroupsSelector({ state, rootState, commit }) {
    if (state.groupsSelector.status === 'ready') {
      return Promise.resolve(state.groupsSelector.list);
    }
    commit('setGroupsSelectorStatus', 'loading');
    return this.$api.content
      .getGroupsList(rootState.user.session.token)
      .then((response) => {
        const list = response.data.channelSelectorActive
          ? response.data.selectorChannels
          : [];
        commit('setGroupsSelector', list);
        return list;
      });
  },

  addStopIndex({ commit }, payload) {
    commit('setStopIndex', {
      play: {
        indexes: {
          stop: payload.time
        }
      }
    });
  },

  selectContent({ commit }, payload) {
    commit('setCourse', payload);
  },

  addCourseFinished({ commit }, payload) {
    commit('setCourseFinished', payload);
  },

  setContentToPlayer({ commit }, payload) {
    commit('setContentToPlayer', payload);
  },

  getPlayerContent() {
    const course = DeviceStorage.get('contentToPlayer') || null;

    return course
      ? Promise.resolve(course)
      : Promise.reject({ message: 'Content to player data not found.' });
  },

  checkCourse() {
    const course = DeviceStorage.get('course') || null;
    return course
      ? Promise.resolve(course)
      : Promise.reject({ message: 'Course data not found.' });
  },

  loadQuizData({ commit }, { id, utoken, contentId }) {
    return this.$api.questionnaire
      .startQuestionnaire(id, utoken, contentId)
      .then((response) => {
        commit('setQuizId', id);
        commit('setQuizData', response.data);
        return response.data;
      })
      .catch((err) => {
        return Promise.resolve(err);
      });
  },

  saveQuizData({ commit }, payload) {
    commit('setQuizResult', payload);
  }
};
